import React, {useEffect, useState} from 'react';
import {useAuth} from "../../providers/AuthProvider";
import {apiGet, extractPayloadFromResponse} from "../../services/apiService";
import {useSiteMessage} from "../../providers/SiteMessageProvider";
import {AuthorBadge, AuthorBadgeVariant} from "@varymadellc/my-weed-club-component-library";
import defaultProfileImage from "../../assets/imgs/profilePic.png";
import imagePathFromFile from "../../utils/imagePathFromFile";
import {useRouter} from "next/navigation";

export interface AudioProps {
    uuid: string;
    className?: string;
    fullWidth?: boolean;
    variant?: AuthorBadgeVariant;
    onData?: (data: any) => void;
    onClick?: () => void;
}

export default function AuthorBadgeByUuid({
  uuid,
  className,
  fullWidth,
  variant = AuthorBadgeVariant.small,
  onData,
  onClick
}: AudioProps) {
    const navigate = useRouter();

    const {authToken} = useAuth();

    const {setMessage} = useSiteMessage();

    const [username, setUsername] = useState<string>('');

    const [profileImage, setProfileImage] = useState<string>(defaultProfileImage as unknown as string);

    useEffect(() => {
        (async () => {
            try {
                if (!uuid) return;

                const authorsDataJson = localStorage.getItem(uuid);

                const authorsData = JSON.parse(authorsDataJson || '{}');

                const hasExpired = Date.now() > Number(authorsData?.expireDate || 0);

                if (uuid && authorsData && !hasExpired) {
                    if (authorsData?.username) {
                        setUsername(authorsData?.username);
                    }

                    if (authorsData?.file?.[0]) {
                        setProfileImage(authorsData?.file?.[0]);
                    }

                    onData && onData(authorsData);

                    return;
                }

                const authorProfileResponse = await apiGet(`/public/account/${uuid}`, authToken);

                const authorProfile = await extractPayloadFromResponse(authorProfileResponse);

                if (authorProfile.error) {
                    throw new Error(authorProfile.error);
                }

                const dateNow = new Date();

                const dateToExpire = new Date();

                dateToExpire.setDate(dateNow.getDate() + 1);

                localStorage.setItem(uuid, JSON.stringify({
                    username: authorProfile.username,
                    file: authorProfile.file[0],
                    expireDate: dateToExpire.getTime().toString()
                }));

                setUsername(authorProfile.username);

                setProfileImage(authorProfile.file[0]);

                onData && onData(authorProfile);
            } catch (error: any) {
                setMessage(error.message);
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    const clickHandler = () => {
        typeof onClick === 'function'
            ? onClick()
            : navigate.push(`/u/${username}`);
    };

    return (
        <>
            <input type="hidden" value={uuid}/>
            <AuthorBadge fullWidth={fullWidth} variant={variant} onClick={clickHandler} className={className}
                         name={username}
                         profileImage={imagePathFromFile(profileImage)}/>
        </>
    )
}